import React from "react";
import { Container, Row, Col } from "react-bootstrap";


class Footer extends React.Component{
  render(){
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col  >
            <img src='https://static.igem.wiki/teams/4298/wiki/white-logo.png' alt="Logo" />
            <img src='https://static.igem.wiki/teams/4298/wiki/foot1.png' alt="Logo" />
            <img src='https://static.igem.wiki/teams/4298/wiki/foot2.png' alt="Logo" />
            
          </Col>
          <Col>
          <img src='https://static.igem.wiki/teams/4298/wiki/snapgene-logo.png' alt="Logo" />
          </Col>

        </Row>
        <Row className="align-items-center">
        <Col   className="text-center text-sm-end">
            <p> ©2022 PEKING IGEM. All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
      );
    
    }
  
   
    
  }
  export default Footer;
